import React from "react"
import { IconProps } from "./iconTypes"

const IconStarOutline = ({
  size = 24,
  flexible = false,
  className,
  color,
  ...props
}: IconProps) => (
  <svg
    {...props}
    viewBox="0 0 16 16"
    width={flexible ? undefined : size}
    height={flexible ? undefined : size}
    fill={color}
    className={`icon ${className ? className : ""}`}
  >
    <path
      d="M8.00026 -6.10352e-05C8.27917 -6.10352e-05 8.53383 0.157584 8.6551 0.409211L10.7348 4.69292L15.3793 5.37808C15.6521 5.41749 15.8795 5.60848 15.9644 5.87223C16.0493 6.13599 15.9796 6.42096 15.7855 6.61499L12.4174 9.95586L13.2117 14.6731C13.2571 14.9459 13.145 15.2218 12.9176 15.3855C12.6902 15.5492 12.3931 15.5674 12.1506 15.4371L7.99723 13.2179L3.84994 15.434C3.60438 15.5644 3.30728 15.5462 3.08294 15.3825C2.85859 15.2188 2.74339 14.9429 2.78887 14.6701L3.58316 9.95283L0.214999 6.61499C0.0179424 6.42096 -0.0487538 6.13296 0.0361323 5.87223C0.121018 5.61151 0.348392 5.42052 0.62124 5.37808L5.26572 4.69292L7.34543 0.409211C7.46972 0.157584 7.72135 -6.10352e-05 8.00026 -6.10352e-05ZM8.00026 2.39494L6.40865 5.67518C6.30254 5.89042 6.09942 6.04201 5.85992 6.07839L2.27349 6.60589L4.87767 9.18582C5.04441 9.35256 5.12323 9.58903 5.08382 9.82247L4.4684 13.4513L7.65769 11.7476C7.87293 11.6324 8.13062 11.6324 8.34284 11.7476L11.5321 13.4513L10.9197 9.8255C10.8803 9.59206 10.9561 9.35559 11.1259 9.18885L13.7301 6.60892L10.1436 6.07839C9.90717 6.04201 9.70101 5.89346 9.59491 5.67518L8.00026 2.39494Z"
      fill="#127D89"
    />
  </svg>
)

export default IconStarOutline
